import { render, staticRenderFns } from "./TimeRange.vue?vue&type=template&id=586a86aa&scoped=true&"
import script from "./TimeRange.vue?vue&type=script&lang=ts&"
export * from "./TimeRange.vue?vue&type=script&lang=ts&"
import style0 from "./TimeRange.vue?vue&type=style&index=0&id=586a86aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586a86aa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
